export default {
    resalesLanding: {
        sentOn: "أُرسل في",
        toggleContact: "إظهار/إخفاء بيانات الاتصال بالوكالة",
        propertyOffers: "عروض العقارات",
        openGallery: "فتح معرض الصور",
        prevPhoto: "الصورة السابقة",
        nextPhoto: "الصورة التالية",
        close: "إغلاق",
        photo: "صورة",
        description: "الوصف",
        more: "المزيد",
        less: "أقل",
        intFloorSpace: "المساحة الداخلية",
        build: "المساحة المبنية",
        terrace: "تراس",
        garden: "حديقة",
        buildYear: "سنة البناء",
        fees: "الرسوم",
        communityFees: "رسوم الخدمات المشتركة",
        basuraTax: "رسوم النفايات (Basura)",
        ibiFees: "IBI (الضريبة العقارية)",
        securityDeposit: "مبلغ التأمين",
        perMonth: "/شهر",
        perWeek: "/أسبوع",
        disclaimer: "إخلاء المسؤولية",
        energyCertificate: "شهادة كفاءة الطاقة",
        pending: "قيد الانتظار",
        rating: "التصنيف",
        presentedBy: "مقدَّم من",
        propertyDetails: "تفاصيل العقار",
        reference: "الرقم المرجعي",
        referenceShort: "مرجع",
        unitUnavailable: "لم يعد متاحًا",
        availableUnits: "الوحدات المتاحة والأسعار",
        availableUnitsShort: "الوحدات المتاحة",
        unit: "الوحدة",
        type: "النوع",
        floors: "الطوابق",
        bedrooms: "غرف النوم",
        bathrooms: "الحمامات",
        surfaceArea: "داخلي",
        price: "السعر",
        status: "الحالة",
        unitAvailable: "متاحة",
        unitReserved: "محجوزة",
        unitSold: "مباعة",
        seeMore: "عرض المزيد",
        seeLess: "عرض أقل",
        floor: "الطابق",
        storeys: "عدد الطوابق",
        keyReady: "جاهزة للتسليم",
        touristLicence: "رخصة سياحية",
        firstOccupationLicence: "رخصة الإشغال الأول",
        notKnown: "غير معروف",
        notProvided: "غير محدد",
        yes: "نعم",
        no: "لا",
        mortgageAvailable: "التمويل العقاري متاح",
        guaranteedRental: "إيجار مضمون",
        sellBeforeCompletion: "التنازل عن العقد قبل الإنجاز",
        sellBeforeCompletionYes: "مسموح",
        sellBeforeCompletionNo: "غير مسموح",
        sellBeforeCompletionNotProvided: "غير محدد",
        reservation: "الحجز",
        contract: "العقد",
        construction: "البناء",
        completion: "الإنجاز",
        co2: "CO2",
        energyConsumption: "استهلاك الطاقة",
        co2PerYear: "كجم CO2/سنة",
        kwhPerYear: "كيلوواط ساعة/سنة",
        features: "المميزات",
        viewDetails: "عرض التفاصيل",
        hideDetails: "إخفاء تفاصيل العقار",
        backToResults: "النتائج",
        viewProperty: "عرض العقار",
        prevProperty: "السابق",
        nextProperty: "التالي",
        viewAllFeatures: "عرض جميع المميزات",
        allFeatures: "جميع المميزات",
        infoOnRequest: "المعلومات عند الطلب",
        tbc: "غير معروف",
        featureCategoryLabels: { pool: "مسبح", views: "إطلالات", parking: "موقف سيارات", kitchen: "مطبخ", condition: "الحالة", garden: "حديقة" },
        featureQualifierFormat: "{category} {value}",
        location: "الموقع",
        agencyInformation: "معلومات الوكالة",
        buyingCosts: "تكاليف الشراء",
        propertyPrice: "سعر العقار:",
        priceNote: "**السعر لا يشمل الضرائب أو تكاليف الشراء.",
        estimatedPurchaseCosts: "تكاليف الشراء التقديرية:",
        hide: "إخفاء",
        showBreakdown: "عرض تفصيل تكاليف الشراء",
        purchaseCostBreakdown: "تفصيل تكاليف الشراء",
        concept: "البند",
        application: "التطبيق",
        rowTransferTax: "ITP (ضريبة نقل الملكية، عقار مُعاد بيعه)",
        rowVat: "ضريبة القيمة المضافة (بناء جديد)",
        rowVatLand: "ضريبة القيمة المضافة",
        vatApplication: "‏10% (‏4% للإسكان المدعوم)",
        rowStampDuty: "رسم الدمغة (AJD)",
        rowNotary: "كاتب العدل",
        rowLandRegistry: "السجل العقاري",
        officialTariff: "التعرفة الرسمية",
        costRangeNotePrefix: "*تتراوح التكاليف الإجمالية للمشتري عادةً بين",
        and: "و",
        ofPurchasePrice: "من سعر الشراء.",
        costApproxNote: "*تُقدَّم تكاليف الشراء التقديرية للاسترشاد فقط. وقد تختلف التكاليف الفعلية حسب العقار وظروف المشتري. نوصي بالحصول على استشارة مهنية للحصول على حساب دقيق.",
        additionalInformation: "معلومات إضافية",
        addInfoDocument: "*وثيقة معلومات مختصرة متاحة وفقًا للمرسوم الأندلسي 218/2005",
        addInfoNoFees: "*لا يدفع المشتري عمولة الوكالة العقارية",
        formHeading: "هل ترغب في معرفة المزيد عن الأسعار والعقار؟",
        firstName: "الاسم الأول",
        enterNumber: "أدخل الرقم",
        email: "البريد الإلكتروني",
        searchCountry: "ابحث عن دولة أو رمز",
        noMatches: "لا توجد نتائج",
        consent: "بالنقر على الزر، فإنك توافق على معالجة بياناتك الشخصية وفقًا لسياسة الخصوصية، بما في ذلك جمع المعلومات المقدَّمة وتخزينها واستخدامها للتواصل معك وتزويدك بالمعلومات اللازمة.",
        send: "إرسال",
        contactUs: "اتصل بنا",
        yourMessage: "رسالتك",
        agreeData: "أوافق على تقديم بياناتي لغرض تلقي رد على طلب المعلومات الخاص بي.",
        agreeContact: "أطلب الحصول على المعلومات وأوافق على أن تتواصل معي الشركة المسؤولة عن المشروع أو جهة التسويق المعنية عبر بيانات الاتصال التي أقدمها طوعًا لهذا الغرض.",
        reject: "رفض",
        like: "إعجاب",
        liked: "محفوظ",
        rejected: "مرفوض",
        offerRejected: "تم رفض العرض",
        contact: "اتصال",
        call: "اتصل",
        calling: "جارٍ الاتصال بـ",
        noPhone: "لا يوجد رقم هاتف متاح",
        enquirySent: "تم إرسال الطلب — سنتواصل مع",
        yourDetails: "بياناتك",
        respondedTo: "تم الرد عليها",
        noProperties: "لا توجد عقارات لعرضها.",
        soldOutBody: "تم بيع العقارات الواردة في هذا العرض أو لم تعد معروضة في السوق. يرجى التواصل مع الوكالة للحصول على مجموعة محدثة.",
        expiredTitle: "انتهت صلاحية رابط العرض هذا",
        expiredBody: "يرجى التواصل مع الوكالة للحصول على رابط محدَّث لعرض هذه العقارات.",
        unavailableTitle: "العرض غير متاح",
        unavailableBody: "تعذّر تحميل هذا العرض. قد يكون الرابط غير صالح أو الخدمة غير متاحة مؤقتًا — يرجى المحاولة لاحقًا أو التواصل مع الوكالة.",
    },
    title: "{agencyName}'s properties",
    in: "in",
    propertiesFound: "properties found",
    toDay: "Today",
    days: "days",
    week: "Week",
    year: "Year",
    month: "Month",
    prev: "Prev",
    next: "Next",
    backToList: "Back to List",
    sorry: "Sorry , we",
    cantFind: "can't find",
    lookingFor: "the page you're looking for...",
    thankYou: "THANK YOU FOR VISITING OUR WEBSITE",
    pleaseContact: "Please contact the Agent for a new URL.",
    ForSale: "SALE",
    ShortTermRental: "Short Rent",
    LongTermRental: "Long Rent",
    showMore: "Show More",
    showLess: "Show Less",
    price: "Price",
    pricePer: "Price per",
    built: "Build",
    terrace: "Terrace",
    garden: "Garden",
    plot: "Plot",
    propTitle: '{subType} {searchType} in {location}',
    propTitleShort: '{subType} in {location}',
    notAvailable: "Not Available",
    notFound: 'Page not found',
    emptyProperties: "No properties were found, please contact your Agent for more information.",
    linkExpired: "Oops, this link has expired. Contact your estate agent to receive an updated property link.",
    newDevelopment: "New Development",
    agencyRaiiNo: "Agency's registration number",
    home: {
        verifyYourURLHere: "Verify your URL here. To do this, login to WhatsApp on your web browser, then copy the URL from WhatsApp to here.",
        pasteUrlHere: "Paste URL here",
        verifyUrl: "Verify URL",
        whatIsPropertyViewer: "What is Property-Viewer.com?",
        thisIsWebsiteIsUsed: "This website is used by Estate Agents to send properties to their clients. It is a product of  {resalesonlinecom} If in doubt, please speak to the Agent who sent your property list to you.",
        howDoesItWork: "كيف يعمل؟",
        inThePast: "في الماضي، كان الوكلاء يرسلون وثائق PDF إلى عملائهم. ومع ذلك، هذه ليست سهلة لعرضها على العديد من الأجهزة. لذلك أنشأنا {propertyviewercom} بحيث يمكن للعميل عرض الخصائص المرسلة إليهم بسهولة أكبر.",
        createAShortList: "سيقوم \"الوكيل\" بإنشاء قائمة قصيرة من الخصائص. عندما يشاركون هذه الخصائص معك، سوف تتلقى رابط. النقر على هذا الرابط سوف تظهر لك خصائص."
    },

    list: {
        propertyTitle: "انقر هنا لعرض المعلومات الخاصة بهذه الخاصية"
    },

    searchType: {
        ForSale: "for sale",
        ShortTermRental: "for short term rent",
        LongTermRental: "for long term rent",
    },

    rsStatus: {
        Available: "Available",
        Listing: "Listing",
        UnderOffer: "Under Offer",
        SaleAgreed: "Sale Agreed",
        OffMarket: "Off Market",
        Sold: "Sold",
        Rented: "Rented"
    },

    details: {
        average: "Average",
        averagePricesFor: "Average prices for ",
        showFullER: "Show Full",
        thisProperty: "This property",
        infoNotAvailable: "This information is not available.",
        feesEnergyRating: "Fees, Energy Rating",
        fees: "Fees",
        ibiFees: "IBI Fees",
        basuraTax: "Basura Tax",
        communityFees: "Community Fees",
        associatedCosts: "Associated Costs",
        energyRating: "Energy Rating",
        securityDeposit: "Security Deposit",
        energyCertificate: "Energy certificate",
        energyCertificatePending: "The energy certificate is pending",
        energyConsumption: "Energy Consumption",
        co2: "CO₂",
        co2PerYear: "kgCO₂/m² per year",
        kwhPerYear: "kWh/m² per year",
        other: "Other info",
        buildYear: "Build year",
        forSale: "For sale",
        sold: "Sold",
        longTerm: "Long term",
        shortTermHigh: "Short term high",
        shortTermLow: "Short term low",
        allFeatures: "All features",
        aproxLocation: "Aprox. Location",
        listingAgent: "Listing agent",
        notIncludeExpensesAndTaxes: "El precio no incluye gastos ni tributos. Los gastos adicionales al precio por parte del comprador son: Vivienda nueva/1ª transmisión Impuesto sobre el Valor Añadido (IVA) 10% (o 4% en caso de vivienda protegida); o en el caso de 2ª y/o posteriores transmisiones Impuesto sobre Transmisiones (ITP) según normativa autonómica vigente. Además, la formalización en documento público del contrato de compraventa (escrituras) podrá estar sujeta a AJD (Actos Jurídicos Documentados) según normativa aplicable, así como gastos de inscripción en el Registro y notaría. Información precontractual disponible conforme a la normativa aplicable en la Comunidad Autónoma correspondiente.",
        rentalLicenseRef: "Номер туристической регистрации",
        agencyInformation: "Agency Information",
    },
};
